<template >
	<div class="dataInfo">
		<!-- 筛选框 -->
		<div class="nav">
			<el-row>
				<el-col :span='15'>
					<el-row>
						<el-col :span='7'>
							<!-- 状态筛选 -->
							<div>
								<el-select v-model="statusValue" clearable @change='changeStatusList' placeholder="请选择实验状态" size='small'>
									<el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span='7'>
							<!-- 组名筛选 -->
							<div>
								<el-select v-model="groupValue" clearable placeholder="请选择实验分组" size='small'>
									<el-option v-for="item in groupOptions" :key="item.id" :label="item.groupName" :value="item.id">
									</el-option>
								</el-select>
							</div>
						</el-col>
						<el-col :span='7'>
							<div>
								<el-input placeholder="请输入关键字" v-model="key" clearable size='small'></el-input>
							</div>
						</el-col>
						<el-col :span='3'>
							<div class="btn">
								<el-button size="small" type='primary' @click="searchList">搜索</el-button>
							</div>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span='9'>
					<div class="cao">
						<span v-if="statusValue == 2" :class="{'current': active == 1}" @click="changeStatus(1)"><i class="el-icon-check"></i>批准</span>
						<span v-if="statusValue == 2" :class="{'current': active == 2}" @click="changeStatus(2)"><i class="el-icon-circle-close"></i>拒绝</span>
						<span :class="{'current': active == 3}" @click="changeStatus(3)"><i class="el-icon-upload2"></i>导出</span>
					</div>
				</el-col>
			</el-row>
		</div>

		<!-- 表格 -->
		<el-table ref="multipleTable" class="tableData" :data="tableData" tooltip-effect="dark" :cell-style="tableCellStyle" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor" v-loading="loading" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55"></el-table-column>
			<el-table-column prop='userName' label="参与者"></el-table-column>
			<!-- <el-table-column prop="acceptTimeStr" label="接受时间"></el-table-column> -->
			<el-table-column prop="createTimeStr" label="开始时间"></el-table-column>
			<el-table-column prop="lastLiveTime" label="上次连接时间"></el-table-column>
			<el-table-column prop="leaveTime" label="断连时间"></el-table-column>
			<el-table-column align='center' label="状态" width="150">
				<template slot-scope="scope">
					<div>
						<span v-if="scope.row.status == 1" style="color: #333">已接受</span>
						<span v-if="scope.row.status == 2" style="color: #1570eb">已提交</span>
						<span v-if="scope.row.status == 3" style="color: #259b24">已批准</span>
						<span v-if="scope.row.status == 4" style="color: #ff9800">已拒绝</span>
						<span v-if="scope.row.status == 7" style="color: #ff0800">已放弃</span>
						<span v-if="scope.row.status == 5" style="color: #f39800">已退回</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<div>
						<el-button type='primary' size='mini' style="height: 27px" @click="goDetail(scope.$index, scope.row)">
							<span style="font-size: 13px">查看</span>
						</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<div style="margin-top: 20px; float:right;" v-if="tableData.length > 0">
			<el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="page" :page-sizes="[10, 20, 30, 40, 50]" :page-size="size" layout="total, prev, pager, next, sizes, jumper" :total="tableData.length"></el-pagination>
		</div>

	</div>
</template>

<script>
import { export2Excel } from '../../utils/excel'
export default {
	data() {
		return {
			// 0 全部 1已接受2已提交3已批准 和自动批准4已拒绝5已退回 7已放弃
			statusOptions: [{ value: 0, label: '全部' }, { value: 1, label: '已接受' }, { value: 2, label: '已提交' },
			{ value: 3, label: '已批准' }, { value: 4, label: '已拒绝' }, { value: 5, label: '已退回' },
			{ value: 7, label: '已放弃' },], // 状态筛选
			groupOptions: [{ value: 1, label: '组名1' }, { value: '2', label: '组名2' }, { value: '3', label: '组名3' },], // 组名筛选
			statusValue: 0,  // 状态
			groupValue: '',  // 组名
			key: '',  // 关键字
			active: '',  // 筛选
			tableData: [],
			loading: false,
			size: 10,
			page: 1,
			total: 10,
			projectId: '',
			multipleSelection: [],
			idList: [],
			ringUserIdList: '',
			ringList: [],
		}
	},

	created() {
		if (this.$route.query.id) {
			this.projectId = +this.$route.query.id
		} else {
			this.projectId = +this.$store.state.projectId
		}
		this.getGroupList()
		this.getExperimentDataList()
	},

	methods: {
		// 改变筛选状态
		changeStatus(current) {
			this.active = current
			if (this.active == 1) {
				if (this.tableData.length == 0) {
					this.$message({
						type: 'warning',
						message: "暂无数据"
					})
				} else if (this.multipleSelection.length == 0) {
					this.$message({
						type: 'warning',
						message: "请选择工人"
					})
				} else {
					this.approveList()
				}
			} else if (this.active == 2) {
				if (this.tableData.length == 0) {
					this.$message({
						type: 'warning',
						message: "暂无数据"
					})
				} else if (this.multipleSelection.length == 0) {
					this.$message({
						type: 'warning',
						message: "请选择工人"
					})
				} else {
					this.refuseList()
				}
			} else if (this.active == 3) {
				if (this.tableData.length == 0) {
					this.$message({
						type: 'warning',
						message: "暂无数据"
					})
				} else if (this.multipleSelection.length == 0) {
					this.$message({
						type: 'warning',
						message: "请选择工人"
					})
				} else {
					this.exportList()
				}
			}
		},

		// 改变筛选状态更新列表
		changeStatusList() {
			this.getExperimentDataList()
		},

		// 获取小组列表
		getGroupList() {
			this.loading = true
			this.httpPost('/web/group/v1/searchGroupList', {
				id: this.projectId
			}).then(res => {
				if (res.code == 0) {
					this.loading = false
					if (res.data) {
						this.groupOptions = res.data
					} else {
						this.groupOptions = []
					}
				} else if (res.code == 10001 || res.code == 10002) {
					this.loading = false
					this.$message({
						type: 'error',
						message: res.message
					})
				} else {
					this.loading = false
					this.$message({
						type: 'error',
						message: res.message
					})
				}
			})
		},

		// 点击搜索
		searchList() {
			this.getExperimentDataList()
		},

		// 获取列表结果
		getExperimentDataList() {
			this.loading = true
			this.httpPost('/web/answer/v1/searchAnswerList', {
				groupId: this.groupValue,
				keywords: this.key,
				pageNum: this.page,
				pageSize: this.size,
				projectId: this.projectId,
				status: this.statusValue,
			}).then(res => {
				if (res.code == 0) {
					this.loading = false
					var ringUserIdList = [];
					res.data.data.forEach((item, index, array) => {
						//执行代码
						ringUserIdList.push(item.ringUserId)
					})
					this.httpPost('/web/answer/v1/searchDetectionLog', {
						ringUserIdList: ringUserIdList
					}).then(res2 => {
						var dataLive = res2.data;
						var dataTemp = res.data.data;
						var tabledata = [];
						dataTemp.forEach((item, index, array) => {
							dataLive.forEach((item2, index2, array2) => {
								if (item.ringUserId === item2.ringUserId) {
									item.lastLiveTime = item2.lastLiveTime;
									item.leaveTime = item2.leaveTime;
								}
							})
							tabledata.push(item);
						})
                        this.tableData = tabledata;
					})

				} else if (res.code == 10001 || res.code == 10002) {
					this.loading = false
					this.$message({
						type: 'error',
						message: res.message
					})
				} else {
					this.loading = false
					this.$message({
						type: 'error',
						message: res.message
					})
				}
			})
		},

		// 选中状态改变
		handleSelectionChange(val) {
			this.idList = []
			this.ringUserIdList = ''
			this.ringList = []
			this.multipleSelection = val;
			this.multipleSelection.forEach(item => {
				this.idList.push(item.id)
				this.ringList.push(item.ringUserId)
				this.ringUserIdList = this.ringList.join(',')
			})
		},

		// 批准
		approveList() {
			this.loading = true
			this.httpPost('/web/answer/v1/approvalAnswer', {
				idList: this.idList,
				projectId: this.projectId
			}).then(res => {
				if (res.code == 1) {
					this.loading = false
					this.$message({
						type: 'success',
						message: res.message
					})
					this.getExperimentDataList()
					this.idList = []
				} else if (res.code == 10001 || res.code == 10002) {
					this.loading = false
					this.$message({
						type: 'error',
						message: res.message
					})
				} else {
					this.loading = false
					this.$message({
						type: 'error',
						message: res.message
					})
				}
			})
		},

		// 拒绝
		refuseList() {
			this.loading = true
			this.httpPost('/web/answer/v1/refuseAnswer', {
				idList: this.idList,
				note: "string",
				projectId: this.projectId,
				reason: "string"
			}).then(res => {
				if (res.code == 1) {
					this.loading = false
					this.$message({
						type: 'success',
						message: res.message
					})
					this.idlist = []
					this.getExperimentDataList()
				} else if (res.code == 10001 || res.code == 10002) {
					this.loading = false
					this.$message({
						type: 'error',
						message: res.message
					})
				} else {
					this.loading = false
					this.$message({
						type: 'error',
						message: res.message
					})
				}
			})
		},

		/*导出结果*/
		exportList() {
			this.$confirm('此操作将导出列表, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				window.location.href = "https://www.ringdata.com/cloudexperiment/web/answer/v1/export?projectId=" + this.projectId + '&ids=' + this.ringUserIdList;
			}).catch(() => {
				this.$message.info('已取消！');
			});
		},

		// 跳转到详情页
		goDetail(index, row) {
			this.$router.push({
				path: '/data/detail',
				query: {
					id: this.projectId,
					workerId: row.ringUserId,
					hitId: row.id,
					ringUserId: row.ringUserId,
					status: row.status,
					name: row.userName
				}
			})
		},

		/*修改table tr行的背景色*/
		tableRowStyle({ row, rowIndex }) {
			return "text-align: center;";
		},
		/*修改table tr行的背景色*/
		tableCellStyle({ row, rowIndex }) {
			return "height: 30px;text-align: center;";
		},
		/*修改table header的背景色*/
		tableHeaderColor({ row, column, rowIndex, columnIndex }) {
			if (rowIndex === 0) {
				return "background-color: #f5f7f9;  font-weight: bold;text-align: center;";
			}
		},
		/*每页记录数改变时*/
		sizeChange: function (size) {
			this.size = size;
			this.getExperimentDataList();
		},

		/*页码改变时*/
		currentChange: function (curr) {
			this.page = curr;
			this.getExperimentDataList();
		}
	}
}
</script>

<style scoped>
.nav >>> .el-button--small {
	padding: 7.5px 15px;
	font-size: 12px;
	border-radius: 3px;
}
.dataInfo >>> .el-table th {
	height: 45px;
	color: #777;
	white-space: nowrap;
	overflow: hidden;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	user-select: none;
	background-color: #59a7ce42 !important;
}
</style>
<style lang="scss" scoped>
.btn {
	margin-top: 1px;
	button {
		display: inline-block;
		margin-left: 10px;
		height: 29px;
	}
}
.cao {
	width: 100%;
	text-align: right;
	span {
		cursor: pointer;
		border-radius: 4px;
		display: inline-block;
		padding: 5px 10px;
		border: 1px solid #ccc;
		margin-left: 20px;
		color: #333;
		font-size: 13px;
		&:hover {
			background-color: #3c82a8;
			border: 1px solid #3c82a8;
			color: #fff;
		}
		i {
			font-weight: bold;
			padding-right: 5px;
			font-size: 14px;
		}
	}
}
.tableData {
	width: 100%;
	margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/data/data.vue